import React, { useState, useCallback, useMemo } from 'react'
import { Spinner } from '@web/walter-ui-kit'

import { GetProducts } from '@web/walter-lib/api'
import Header from './components/Header'
import { CardsViews } from './types'
import NoCards from './NoCards'
import NewCards from './NewCards'
import NewCard from './NewCard'
import Cards from './Cards'
import Error from './Error'
import s from './s.module.css'
import PageLayout from '~components/PageLayout'
import { useInitial, useOpenNoCardsTopUp } from '~pages/CardsPage/hooks'
import OpenNoCardsTopupModal from '~pages/CardsPage/Cards/OpenNoCardsTopupModal'
import CardsListModal from '~pages/CardsPage/Cards/CardsListModal'
import { useCards } from '~api'

function CardsPage() {
    const [view, setView] = useState<CardsViews>(CardsViews.NoCards)
    const [currentProduct, setCurrentProduct] = useState<GetProducts>()
    const [openNoCardsTopup, setOpenNoCardsTopup] = useState({ isOpen: false, currency: '' })
    const [cardsListModal, setCardsListModal] = useState({ isOpen: false })
    const [selectedId, setSelectedId] = useState<string>('')

    const { isLoading, isError } = useInitial(setView, view)

    useOpenNoCardsTopUp(setOpenNoCardsTopup)

    const setNewCardView = useCallback((newView: CardsViews) => {
        setView(newView)
        setSelectedId('')
    }, [])

    const { data: cards } = useCards()

    const selectedCard = useMemo(() => {
        return cards?.cards?.find(card => card.id === selectedId)
    }, [cards?.cards, selectedId])

    if (isLoading) {
        return (
            <div className={s.spinner}>
                <Spinner intent="accent" size={36} />
            </div>
        )
    }

    if (isError) {
        return <Error />
    }

    return (
        <>
            <OpenNoCardsTopupModal
                isOpen={openNoCardsTopup.isOpen}
                currency={openNoCardsTopup.currency}
                onClose={() => setOpenNoCardsTopup({ isOpen: false, currency: '' })}
            />
            <CardsListModal
                isOpen={cardsListModal.isOpen}
                onClose={() => setCardsListModal({ isOpen: false })}
                setSelectedId={setSelectedId}
                selectedCard={selectedCard}
                setView={setView}
            />
            <PageLayout
                contentWidth="xl"
                header={
                    <Header
                        view={view}
                        setView={setView}
                        selectedCard={selectedCard}
                        setCardsListModal={setCardsListModal}
                    />
                }
            >
                {view === CardsViews.NoCards && <NoCards setView={setView} />}
                {view === CardsViews.NewCards && (
                    <NewCards setCurrentProduct={setCurrentProduct} currentProduct={currentProduct} setView={setView} />
                )}
                {view === CardsViews.NewCard && <NewCard product={currentProduct} setView={setNewCardView} />}
                {view === CardsViews.Cards && (
                    <Cards setView={setView} selectedCard={selectedCard} setSelectedId={setSelectedId} />
                )}
            </PageLayout>
        </>
    )
}

export default CardsPage
